export default __webpack_public_path__ + "static/icon-21-5-9b12728dde393d2b625cad2ca6abf6ae.png";